import MaterialTable, { Column } from '@material-table/core';
import Grid from '@mui/material/Grid';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import React, { PropsWithChildren } from 'react';
import { ExportCsv } from '../../../utils/csvExportHelper';
import Dialog from '../../../components/Dialog';
import LoadingSpinner from '../../../components/Loading';
import useTokenGetRequest from '../../../hooks/useTokenGetRequest';
import {
  CarReportType,
  CarType,
  vehicleTableColumns
} from '../../../models/FleetAsset';
import SingleVehicle from './SingleVehicle';
import { useHistory } from 'react-router-dom';
import useNotifier from '../../../hooks/useNotifier';

export default function index(props : PropsWithChildren<{ url: string, hideDeptNumber?: boolean, reportMode?: boolean }>) {
  const { response, error, loading } = useTokenGetRequest<CarType[] | CarReportType[]>(props.url);
  const [tableRowData, setRowData] = React.useState<CarType | CarReportType | null>(
    null
  );
  const history = useHistory();
  const { createNotification } = useNotifier();

  const handleRowClick = (
    event?: React.MouseEvent,
    rowData?: CarType | CarReportType
  ) => {
    try {
      if (rowData !== undefined && rowData.assetId) {
        setRowData(rowData);
        history.push(`/vehicle/${rowData.id}`);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const TableColumnDefinition = vehicleTableColumns(props.hideDeptNumber ?? true, props.reportMode ?? false);
  if(props.reportMode) {
    return (
      <>
        <Grid container direction='column' spacing={3}>
          {
            props.children !== null ? (
            <Grid item>
              {props.children}
            </Grid> 
            ): (<></>)}
          <Grid item>
            <div style={{ height: 600, width: 'auto' }}>
              <MaterialTable
                isLoading={loading}
                columns={TableColumnDefinition as Array<Column<CarReportType>>}
                data={response as CarReportType[] ?? []}
                title={'Vehicle Information'}
                options={{
                  filtering: true,
                  grouping: true,
                  pageSize: 15,
                  pageSizeOptions: [15, 50, 100],
                  emptyRowsWhenPaging: false,
                  exportMenu: [{
                    label: "Export as CSV",
                    exportFunc(columns, renderData, tableData) {
                      ExportCsv(createNotification, columns, renderData, tableData);
                    },
                  }]
                }}                
                onRowClick={handleRowClick}
              />
            </div>
          </Grid>
        </Grid>
      </>
    );

  } else {
    return (
      <>
        <Grid container direction='column' spacing={3}>
          {
            props.children !== null ? (
            <Grid item>
              {props.children}
            </Grid> 
            ): (<></>)}
          <Grid item>
            <div style={{ height: 600, width: 'auto' }}>
              <MaterialTable
                isLoading={loading}
                columns={TableColumnDefinition as Array<Column<CarType>>}
                data={response as CarType[] ?? []}
                title={'Vehicle Information'}
                options={{
                  filtering: true,
                  grouping: true,
                  pageSize: 15,
                  pageSizeOptions: [15, 50, 100],
                  emptyRowsWhenPaging: false,
                  exportMenu: [{
                    label: "Export as CSV",
                    exportFunc(columns, renderData, tableData) {
                      ExportCsv(createNotification, columns, renderData, tableData);
                    },
                  }]
                }}                
                onRowClick={handleRowClick}
              />
            </div>
          </Grid>
        </Grid>
      </>
    );
  }
}
